import styled from 'styled-components';

export const StyledUserIconCircle = styled.div`
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 50%;
  user-select: none;
  transition: 0.5s all ease;

  width: ${({ theme, $size }) => theme?.size?.[$size || 'medium']};
  height: ${({ theme, $size }) => theme?.size?.[$size || 'medium']};
  background-color: ${({ theme }) => theme?.palette?.accent};
  color: ${({ theme }) => theme?.palette?.accentText};
`;

export const StyledUserIconInitial = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -30%);
  text-transform: uppercase;
  transition: 0.5s all ease;
  width: 100%;
  height: 100%;
  padding-top: 3px;
  text-align: center;

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
`;
